<template>
  <v-card id="edit-family-groups">
    <flewid-dialog
      draggable
      scrollable
      persistent
      content-class="i-dialog"
      v-model="showDeleteProductDialog"
      width="400"
    >
      <v-card>
        <template>
          <v-card-title class="i-dialog-header-div">
            <span class="g-heading-m g-bold">
              {{
                minProductsForExistingFamilyGroup
                  ? 'Information'
                  : 'Confirmation'
              }}</span
            >
          </v-card-title>

          <v-card-text class="i-dialog-content-div py-4 text-center">
            <p v-if="minProductsForExistingFamilyGroup">
              Family Group requires at least two products. Delete Family Group
              if required.
            </p>
            <p v-else>Remove product from Family Group?</p>
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions class="i-dialog-actions-div justify-end">
            <template v-if="minProductsForExistingFamilyGroup">
              <v-btn
                rounded
                text
                class="i-btn-text-black"
                @click="cancelDeleteProductFromGroup()"
                >Close</v-btn
              >
            </template>
            <template v-else>
              <v-btn
                class="i-btn-text-black mr-2"
                text
                rounded
                @click="cancelDeleteProductFromGroup()"
              >
                Cancel
              </v-btn>
              <v-btn
                class="i-btn-block-secondary mr-4"
                rounded
                @click="finishDeleteProductFromGroup(productToDeleteFromGroup)"
              >
                Remove
              </v-btn>
            </template>
          </v-card-actions>
        </template>
      </v-card>
    </flewid-dialog>

    <v-card-title class="i-card-title-div">
      <v-row class="align-center">
        <v-col cols="12" sm="9">
          <span class="g-bold g-heading-l">{{
            newFamilyGroup ? 'New Family Group' : 'Edit Family Group'
          }}</span>
        </v-col>
        <v-col cols="12" sm="3">
          <i-instructions
            instructionKey="data-maintenance/family-groups/add-dialog"
          ></i-instructions>
        </v-col>
      </v-row>
    </v-card-title>

    <v-card-text class="py-8 i-card-content-div overflow-y-auto">
      <v-form @submit.prevent>
        <span class="g-bold g-heading-s g-text-color-black"
          >Family Group Name</span
        >
        <v-text-field
          class="mt-2 mt-md-3"
          background-color="#0000000f"
          counter="60"
          maxlength="60"
          dense
          outlined
          v-model="familyGroup.name"
          label="Family Group Name *"
          :rules="[
            (v) => !!v || 'Family Group Name is required',
            (v) =>
              v.length <= 60 || 'Family Group Name cannot exceed 60 characters'
          ]"
        >
        </v-text-field>

        <div class="mt-2">
          <span class="g-bold g-heading-s g-text-color-black">
            List of Products
          </span>
          <v-alert
            dense
            outlined
            text
            border="left"
            class="mt-2"
            elevation="1"
            type="info"
          >
            <div>
              <ul>
                <li>
                  Reason Codes for why products cannot be allocated to the same
                  Family Group
                </li>
                <li>
                  Variable Weight products are not available for Family Groups
                </li>
              </ul>
            </div>
          </v-alert>

          <v-row class="mt-4">
            <v-col cols="4">
              <span>
                <v-chip class="mx-1" small color="orange" text-color="white"
                  ><strong>P</strong>
                </v-chip>
                Price Variation
              </span>
            </v-col>
            <v-col cols="4">
              <span>
                <v-chip class="mx-1" small color="orange" text-color="white"
                  ><strong>T</strong>
                </v-chip>
                Tax Variation
              </span>
            </v-col>
            <v-col cols="4">
              <span>
                <v-chip class="mx-1" small color="orange" text-color="white"
                  ><strong>Q</strong>
                </v-chip>
                Ctn. Qty. Variation
              </span>
            </v-col>
            <v-col cols="4">
              <span>
                <v-chip class="mx-1" small color="orange" text-color="white"
                  ><strong>FG</strong>
                </v-chip>
                In Family Group
              </span>
            </v-col>
            <v-col cols="4">
              <span>
                <v-chip class="mx-1" small color="orange" text-color="white"
                  ><strong>PE</strong>
                </v-chip>
                Future Price Edits
              </span>
            </v-col>
            <v-col cols="4">
              <span>
                <v-chip class="mx-1" small color="orange" text-color="white"
                  ><strong>VW</strong>
                </v-chip>
                Variable Weight
              </span>
            </v-col>
          </v-row>

          <div class="mt-4">
            <span class="g-bold g-heading-xxs g-text-color-black"
              >ADD PRODUCT(S) TO FAMILY GROUP</span
            >
          </div>

          <v-autocomplete
            attach
            background-color="#0000000f"
            class="mt-1 mb-4 autocomplete"
            dense
            hide-details
            :loading="searchLoading"
            :no-filter="true"
            :items="selectableProductsList"
            multiple
            outlined
            ref="autocomplete"
            v-model:search-input="searchInput"
            small-chips
            v-model="familyGroup.productCodes"
            @change="handleAddProductToGroup"
          >
            <template v-slot:selection="{ item }">
              <v-chip
                small
                close
                @click:close="handleDeleteProductFromGroup(item)"
                >{{ item.shortText }}</v-chip
              >
            </template>

            <template v-slot:item="{ item, attrs, on }">
              <v-list-item
                v-bind="attrs"
                v-on="on"
                :disabled="item.disabled"
                #default="{ active }"
              >
                <v-list-item-action>
                  <v-checkbox
                    :input-value="active"
                    :model-value="active"
                    :disabled="item.disabled"
                  ></v-checkbox>
                </v-list-item-action>
                <v-list-item-content>
                  <v-row no-gutters align="center">
                    <span style="font-size: 14px !important">{{
                      item.text
                    }}</span>
                    <v-spacer></v-spacer>
                    <v-chip
                      v-if="item.pricingIssue"
                      class="mx-1"
                      small
                      color="orange"
                      text-color="white"
                      ><strong>P</strong>
                    </v-chip>
                    <v-chip
                      v-if="item.taxIssue"
                      class="mx-1"
                      small
                      color="orange"
                      text-color="white"
                      ><strong>T</strong>
                    </v-chip>
                    <v-chip
                      v-if="item.quantityIssue"
                      class="mx-1"
                      small
                      color="orange"
                      text-color="white"
                      ><strong>Q</strong>
                    </v-chip>
                    <v-chip
                      v-if="item.familyGroupIssue"
                      class="mx-1"
                      small
                      color="orange"
                      text-color="white"
                      ><strong>FG</strong>
                    </v-chip>
                    <v-chip
                      v-if="item.impactingChangesIssue"
                      class="mx-1"
                      small
                      color="orange"
                      text-color="white"
                      ><strong>PE</strong>
                    </v-chip>
                    <v-chip
                      v-if="item.variableWeightIssue"
                      class="mx-1"
                      small
                      color="orange"
                      text-color="white"
                      ><strong>VW</strong>
                    </v-chip>
                  </v-row>
                </v-list-item-content>
              </v-list-item>
            </template>
          </v-autocomplete>

          <v-simple-table
            light
            class="elevation-1 my-4"
            v-if="familyGroupHasProducts"
          >
            <template v-slot:default>
              <thead>
                <tr>
                  <th>PRODUCT DESCRIPTION</th>
                  <th class="text-center">
                    {{ taxDisplayPolicy.primaryTaxLabel.toUpperCase() }}
                  </th>
                  <th v-if="taxDisplayPolicy.showWet" class="text-center">
                    {{ taxDisplayPolicy.wetLabel }}
                    <v-icon
                      class="i-tooltip-color pb-1"
                      small
                      v-tooltip="'Wine Equalisation Tax'"
                    >
                      mdi-help-circle-outline
                    </v-icon>
                  </th>
                  <th class="text-center">ACTIONS</th>
                </tr>
              </thead>

              <tbody>
                <tr
                  :key="product.productCode"
                  v-for="product in familyGroup.products"
                >
                  <td class="py-2">
                    <div>
                      {{ productDisplayName(product) }}
                      <br />
                      <v-chip
                        label
                        x-small
                        class="mr-1"
                        :color="
                          product.status === 'LIVE'
                            ? 'light-green accent-1'
                            : 'grey lighten-2'
                        "
                      >
                        {{ product.status === 'LIVE' ? 'LIVE' : 'NOT LIVE' }}
                      </v-chip>
                      <v-chip
                        v-if="product.hasUpcomingChange"
                        label
                        x-small
                        color="amber accent-2"
                      >
                        UPCOMING CHANGES
                      </v-chip>
                    </div>
                  </td>
                  <td class="text-center">
                    <v-chip
                      :color="product.hasGst ? 'success' : 'error'"
                      small
                      text-color="white"
                    >
                      {{ product.hasGst ? 'YES' : 'NO' }}
                    </v-chip>
                  </td>
                  <td v-if="taxDisplayPolicy.showWet" class="text-center">
                    <v-chip
                      :color="product.hasWet ? 'success' : 'error'"
                      small
                      text-color="white"
                    >
                      {{ product.hasWet ? 'YES' : 'NO' }}
                    </v-chip>
                  </td>
                  <td class="text-center">
                    <v-btn
                      color="error"
                      icon
                      @click="handleDeleteProductFromGroup(product)"
                    >
                      <v-icon size="20px">mdi-delete-outline</v-icon>
                    </v-btn>
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>

          <v-alert
            v-if="!minProductsMet && newFamilyGroup"
            border="left"
            dense
            outlined
            text
            type="error"
            elevation="1"
            class="my-2 i-alert"
          >
            <span>A Family Group requires a minimum of 2 products</span>
          </v-alert>

          <v-alert
            v-if="!minProductsMet && !newFamilyGroup"
            border="left"
            dense
            outlined
            text
            type="error"
            elevation="1"
            class="my-2 i-alert"
          >
            <span
              >A Family Group requires a minimum of 2 products - delete Family
              Group to remove remaining products</span
            >
          </v-alert>

          <template v-if="minProductsMet && activeFamilyGroup">
            <v-alert
              v-if="hasProductsAdded"
              border="left"
              dense
              outlined
              text
              type="info"
              elevation="1"
              class="my-2 i-alert"
            >
              <span
                >Active promotions for added product(s) will apply from
                midnight</span
              >
            </v-alert>

            <v-alert
              v-if="hasProductsRemoved"
              border="left"
              dense
              outlined
              text
              type="info"
              elevation="1"
              class="my-2 i-alert"
            >
              <span
                >Active promotions for deleted product(s) will apply until
                midnight</span
              >
            </v-alert>
          </template>
        </div>

        <div class="mt-6 mt-md-10">
          <span class="g-bold g-heading-s g-text-color-black"
            >Family Group Image</span
          >
          <v-alert
            border="left"
            dense
            outlined
            text
            type="info"
            elevation="1"
            class="mt-4 i-alert"
          >
            <span
              >Image needs to be representative of the Family Group (eg. a range
              of products in the family) & will be displayed in the
              {{ isILR ? 'Customer' : 'Retailer' }} Marketplace</span
            >
          </v-alert>

          <input
            accept="image/x-png,image/png,image/jpeg,image/webp,image/avif,.png,.jpg,.jpeg,.webp,.avif"
            id="image-input"
            ref="fileUploader"
            type="file"
            style="display: none"
            @change="addImage"
          />

          <div class="p-image-wrapper">
            <v-img
              contain
              width="100%"
              height="100%"
              :src="displayImage"
              @error="handleImageError"
            ></v-img>

            <div
              :class="{ show: !displayImage || newImage }"
              class="p-image-overlay d-flex flex-column align-center justify-center"
            >
              <template v-if="!displayImage">
                <label
                  class="p-image-add-label d-flex align-center justify-center"
                  for="image-input"
                >
                  <div>
                    <v-icon class="p-icon">mdi-cloud-upload-outline</v-icon>
                    <p class="g-bold g-heading-s">Click here to upload image</p>
                    <div class="my-2">
                      MAX FILE SIZE: 1MB<br />
                      JPEG (.JPEG/.JPG), PNG (.PNG), WEBP (.WEBP), OR AVIF
                      (.AVIF) FORMAT<br />
                      1000PX WIDTH AND 1000PX HEIGHT
                    </div>
                    <div class="mt-2 px-2 py-1">
                      <div class="p-image-mandatory-tag text-center orange">
                        <span>Mandatory *</span>
                      </div>
                    </div>
                  </div>
                </label>
              </template>

              <template v-else-if="newImage">
                <div class="my-2">
                  <v-btn
                    large
                    rounded
                    class="i-btn-block-secondary p-image-button"
                    @click="confirmImage()"
                    >Confirm</v-btn
                  >
                </div>
                <div class="my-2">
                  <v-btn
                    large
                    rounded
                    class="i-btn-block-white p-image-button"
                    @click="resetImage()"
                    >Cancel</v-btn
                  >
                </div>
              </template>

              <template v-else>
                <div class="my-2">
                  <label
                    class="p-image-add-label d-flex align-center justify-center"
                    for="image-input"
                  >
                    <div class="p-image-button-div elevation-1">Update</div>
                  </label>
                </div>
              </template>
            </div>
          </div>
        </div>
      </v-form>
    </v-card-text>

    <v-card-actions class="i-dialog-actions-div pt-6 justify-end">
      <v-btn rounded text class="i-btn-text-black" @click="$emit('cancel')"
        >Cancel</v-btn
      >
      <v-btn
        rounded
        class="i-btn-block-secondary mr-4"
        :disabled="!validForm"
        :loading="saving"
        @click="save"
        >{{ newFamilyGroup ? 'Create' : 'Update' }}</v-btn
      >
    </v-card-actions>
  </v-card>
</template>

<script>
import _ from 'lodash'
import { mapActions, mapState, mapGetters } from 'vuex'
import { ImageValidationHelper } from '@/components/helpers/ImageValidationHelper'
import {
  createFamilyGroup,
  updateFamilyGroup,
  uploadFamilyGroupImage
} from '@/services/familyGroups'
import { fetchProductsFromBackend } from '@/services/products'

import FlewidDialog from '@/components/FlewidDialog'
import iInstructions from '@/components/Instructions'

const MAX_ALLOWED_IMAGE_SIZE = 1000000
const MAX_ALLOWED_IMAGE_NAME_LENGTH = 200
const MIN_REQUIRED_PRODUCTS = 2
const INITIAL_PRODUCT_SEARCH_PAGE_SIZE = 25

export default {
  components: {
    iInstructions,
    FlewidDialog
  },

  data: () => ({
    saving: false,
    priceMap: [],
    initialProductsList: [],
    showDeleteProductDialog: false,
    searchLoading: false,
    searchResults: [],
    searchInput: '',
    latestSearchTerm: '',
    previousImage: null,
    newImage: null,
    productToDeleteFromGroup: null,
    originalFamilyGroup: {},
    debouncedSearchProducts: null
  }),

  props: {
    familyGroup: Object,
    familyGroups: Array,
    products: Array
  },

  mounted() {
    this.debouncedSearchProducts = _.debounce(this.loadSearchResults, 300)
    this.initializeDialogState()
  },

  beforeUnmount() {
    this.debouncedSearchProducts?.cancel()
  },

  watch: {
    searchInput(value) {
      const normalizedValue = typeof value === 'string' ? value.trim() : ''
      this.latestSearchTerm = normalizedValue

      if (normalizedValue.length < 2) {
        this.debouncedSearchProducts?.cancel()
        this.searchResults = []
        this.searchLoading = false
        return
      }

      this.searchLoading = true
      this.debouncedSearchProducts?.(normalizedValue)
    }
  },

  computed: {
    ...mapState('preferences', ['selectedSupplierId']),
    ...mapGetters('tenant', ['isILR', 'taxDisplayPolicy']),

    hasActiveSearch() {
      return this.latestSearchTerm.length >= 2
    },

    availableProducts() {
      return _.uniqBy(
        [
          ...(this.familyGroup.products || []),
          ...(this.hasActiveSearch ? this.searchResults : this.products || [])
        ],
        'productCode'
      )
    },

    selectableProductsList() {
      return this.availableProducts
        .map((p) => ({
          ...p,
          text: this.productDisplayName(p),
          shortText: p.supplierItemId,
          value: p.productCode,
          familyGroupIssue: this.hasFamilyGroupIssue(p.productCode),
          taxIssue: this.hasTaxIssue(p),
          quantityIssue: this.hasQuantityIssue(p),
          pricingIssue: this.hasPricingIssue(p),
          impactingChangesIssue: this.hasImpactingChangesIssue(p.productCode),
          variableWeightIssue: p.variableWeightTargetInKg,
          disabled:
            this.hasFamilyGroupIssue(p.productCode) ||
            this.hasTaxIssue(p) ||
            this.hasQuantityIssue(p) ||
            this.hasPricingIssue(p) ||
            this.hasImpactingChangesIssue(p.productCode) ||
            p.variableWeightTargetInKg
        }))
        .sort((p1, p2) => (p1.text < p2.text ? -1 : 1))
    },

    displayImage() {
      return this.newImage
        ? URL.createObjectURL(this.newImage)
        : this.familyGroup.imageUrl
    },

    hasImageUrl() {
      return this.familyGroup.imageUrl
    },

    activeFamilyGroup() {
      return this.familyGroup.status === 'LIVE'
    },

    changesMade() {
      return !_.isEqual(this.familyGroup, this.originalFamilyGroup)
    },

    familyGroupHasProducts() {
      return this.familyGroup.products.length > 0
    },

    hasProductsAdded() {
      const listAddedProducts = this.familyGroup.productCodes.filter(
        (product) => !this.initialProductsList.includes(product)
      )
      return !!listAddedProducts.length
    },

    hasProductsRemoved() {
      const listRemovedProducts = this.initialProductsList.filter(
        (product) => !this.familyGroup.productCodes.includes(product)
      )
      return !!listRemovedProducts.length
    },

    newFamilyGroup() {
      return !this.familyGroup?.id
    },

    minProductsMet() {
      return this.familyGroup.productCodes.length >= MIN_REQUIRED_PRODUCTS
    },

    minProductsForExistingFamilyGroup() {
      return (
        !this.newFamilyGroup &&
        this.familyGroup.productCodes.length <= MIN_REQUIRED_PRODUCTS
      )
    },

    validForm() {
      return (
        this.minProductsMet &&
        !!this.familyGroup.name &&
        this.familyGroup.name.length <= 60 &&
        this.hasImageUrl &&
        this.changesMade
      )
    }
  },

  methods: {
    ...mapActions('notifications', ['addNotification']),

    initializeDialogState() {
      if (!this.newFamilyGroup) this.reCalcPriceMap()

      this.originalFamilyGroup = _.cloneDeep(this.familyGroup)
      this.initialProductsList = (this.familyGroup.products || []).map(
        (product) => product.productCode
      )
      this.searchInput = ''
      this.searchResults = []
    },

    displayErrorNotification(errorMessage) {
      this.addNotification({
        color: 'error',
        text: errorMessage
      })
    },

    hasFamilyGroupIssue(productCode) {
      return !!this.familyGroups.find(
        (family) =>
          family.productCodes.includes(productCode) &&
          family.id !== this.familyGroup.id
      )
    },

    /*
      Since the property hasPriceOrRrpImpactingChanges
      only exists in LIVE_FUTURE products, we need to check
      if a LIVE product has a LIVE_FUTURE version of itself
      and copy the property to the original LIVE product
    */
    hasImpactingChangesIssue(productCode) {
      const product = this.availableProducts.find(
        (availableProduct) => availableProduct.productCode === productCode
      )

      return !!product?.hasPriceOrRrpImpactingChanges
    },

    hasTaxIssue(product) {
      if (!this.familyGroup.products[0]) return false
      return (
        this.familyGroup.products[0]?.hasGst !== product.hasGst ||
        this.familyGroup.products[0]?.hasWet !== product.hasWet
      )
    },

    hasQuantityIssue(product) {
      if (!this.familyGroup.products[0]) return false
      return (
        product.packageQuantity !==
        Object.values(this.priceMap)[0]?.packageQuantity
      )
    },

    hasPricingIssue(product) {
      if (!this.familyGroup.products[0]) return false

      let hasIssue = false

      Object.entries(product.regionalPriceMap).forEach((region) => {
        const priceInRegion = this.priceMap.find(
          (r) => r.regionCode === region[0]
        )

        if (
          priceInRegion &&
          (priceInRegion.regionCartonPrice !== region[1][0]?.price ||
            priceInRegion.regionUnitRrp !== region[1][0]?.rrp)
        ) {
          hasIssue = true
        }
      })

      return hasIssue
    },

    handleAddProductToGroup(selectedProducts = []) {
      const listAddedProducts = this.availableProducts.filter((product) =>
        selectedProducts.includes(product.productCode)
      )

      this.familyGroup.products = listAddedProducts
        .map((p) => ({ ...p, text: this.productDisplayName(p) }))
        .sort((p1, p2) => (p1.text < p2.text ? -1 : 1))
      /*
        sorting before priceMap calculation means that
        priceMap values are always populated with values
        of products most at the top of list
      */

      this.reCalcPriceMap()
    },

    async loadSearchResults(searchTerm) {
      try {
        const [liveResponse, liveFutureResponse] = await Promise.all([
          fetchProductsFromBackend(
            this.selectedSupplierId,
            'LIVE',
            0,
            INITIAL_PRODUCT_SEARCH_PAGE_SIZE,
            searchTerm
          ),
          fetchProductsFromBackend(
            this.selectedSupplierId,
            'LIVE_FUTURE',
            0,
            INITIAL_PRODUCT_SEARCH_PAGE_SIZE,
            searchTerm
          )
        ])

        if (this.latestSearchTerm !== searchTerm) return

        const liveProducts = liveResponse?.products || []
        const liveFutureProducts = liveFutureResponse?.products || []
        const liveFutureProductsByCode = liveFutureProducts.reduce(
          (acc, product) => {
            acc[product.productCode] = product
            return acc
          },
          {}
        )

        this.searchResults = liveProducts.map((product) => ({
          ...product,
          hasPriceOrRrpImpactingChanges:
            !!liveFutureProductsByCode[product.productCode]
              ?.hasPriceOrRrpImpactingChanges
        }))
      } catch {
        if (this.latestSearchTerm !== searchTerm) return

        this.searchResults = []
        this.displayErrorNotification(
          'Products could not be searched right now, please try again...'
        )
      } finally {
        if (this.latestSearchTerm === searchTerm) {
          this.searchLoading = false
        }
      }
    },

    handleDeleteProductFromGroup(product) {
      this.showDeleteProductDialog = true
      this.productToDeleteFromGroup = product
    },

    cancelDeleteProductFromGroup() {
      this.showDeleteProductDialog = false
      this.productToDeleteFromGroup = null
    },

    finishDeleteProductFromGroup(product) {
      this.familyGroup.productCodes = this.familyGroup.productCodes.filter(
        (productCode) => productCode !== product.productCode
      )
      this.familyGroup.products = this.familyGroup.products.filter(
        (p) => p.productCode !== product.productCode
      )
      this.reCalcPriceMap()
      this.cancelDeleteProductFromGroup()
    },

    reCalcPriceMap() {
      this.priceMap = []
      this.familyGroup.products.forEach((product) =>
        this.pushProductPricing(product)
      )
    },

    pushProductPricing(product) {
      Object.entries(product.regionalPriceMap).forEach((region) => {
        const hasRegion = !!this.priceMap.find(
          (r) => r.regionCode === region[0]
        )

        if (!hasRegion) {
          this.priceMap.push({
            regionCode: region[0],
            regionCartonPrice: region[1][0]?.price,
            regionUnitRrp: region[1][0]?.rrp,
            packageQuantity: product.packageQuantity
          })
        }
      })
    },

    handleImageError(e) {
      this.familyGroup.imageUrl = undefined
    },

    productDisplayName(p) {
      return `${p.supplierItemId} / ${p.tradeItemDescription}`
    },

    addImage(event) {
      if (!event?.target?.files || event.target.files.length < 1) return

      const validSize = ImageValidationHelper.isValidImageSize(
        event.target.files[0].size,
        MAX_ALLOWED_IMAGE_SIZE
      )
      const validFormat = ImageValidationHelper.isValidImageFormat(
        event.target.files[0].name
      )
      const validName = ImageValidationHelper.isValidImageName(
        event.target.files[0].name
      )
      const validNameLength = ImageValidationHelper.isValidImageNameLength(
        event.target.files[0].name,
        MAX_ALLOWED_IMAGE_NAME_LENGTH
      )

      if (!validSize)
        this.displayErrorNotification('Image file size is larger than 1MB...')
      else if (!validFormat)
        this.displayErrorNotification(
          'Image file must be in JPEG (.jpeg/.jpg), PNG (.png), WEBP (.webp), or AVIF (.avif) format only...'
        )
      else if (!validName)
        this.displayErrorNotification(
          'Image file name allows special characters "space", "_" and "-" only...'
        )
      else if (!validNameLength)
        this.displayErrorNotification(
          `Image file name can be up to ${MAX_ALLOWED_IMAGE_NAME_LENGTH} characters only...`
        )
      else {
        this.previousImage = this.familyGroup.imageUrl
        this.familyGroup.imageUrl = null
        this.newImage = event.target.files[0]
      }
    },

    confirmImage() {
      this.familyGroup.imageUrl = URL.createObjectURL(this.newImage)
      this.familyGroup.newImage = this.newImage
      this.previousImage = null
      this.newImage = null
    },

    resetImage() {
      this.previousImage = null
      this.newImage = null
      this.$refs.fileUploader.value = ''
    },

    save() {
      this.saving = true

      const payload = {
        name: this.familyGroup.name,
        productCodes: this.familyGroup.productCodes,
        newImage: this.familyGroup.newImage
      }

      this.newFamilyGroup
        ? this.createFamilyGroup(payload)
        : this.updateFamilyGroup(payload)
    },

    createFamilyGroup(familyGroup) {
      createFamilyGroup(this.selectedSupplierId, familyGroup)
        .then(({ id }) =>
          familyGroup.newImage
            ? uploadFamilyGroupImage(id, familyGroup.newImage)
            : undefined
        )
        .then(() => {
          this.addNotification({
            color: 'secondary',
            text: `Family group ${familyGroup.name} has been created!`
          })
          this.$emit('save')
        })
        .catch((err) => {
          this.saving = false
          this.handleBackendError(familyGroup, err)
        })
    },

    updateFamilyGroup(familyGroup) {
      updateFamilyGroup(this.familyGroup.id, familyGroup)
        .then(() =>
          familyGroup.newImage
            ? uploadFamilyGroupImage(this.familyGroup.id, familyGroup.newImage)
            : undefined
        )
        .then(() => {
          this.addNotification({
            color: 'secondary',
            text: `Family group ${familyGroup.name} has been updated!`
          })
          this.$emit('save')
        })
        .catch((err) => {
          this.saving = false
          this.handleBackendError(familyGroup, err)
        })
    },

    handleBackendError(familyGroup, err) {
      let msg
      switch (err.response?.data?.code || 'UNKNOWN_ERROR') {
        case 'FAMILY_GROUP_PRODUCTS_MUST_HAVE_SAME_PRICES':
          msg =
            'All products in the Family Group must have the same prices in priced zones'
          break
        default:
          msg = `Error creating ${familyGroup.name}...`
      }
      this.addNotification({ color: 'error', text: msg, timeout: -1 })
    }
  }
}
</script>

<style lang="scss">
.v-input__control,
.v-input__slot {
  cursor: pointer !important;
}
</style>

<style lang="scss" scoped>
@import '@/styles/_variables.scss';

#edit-family-groups {
  display: flex !important;
  flex-direction: column;
  overflow: hidden;
  box-shadow: none;
  background: $bg-secondary-color;
  .v-card__text {
    flex-grow: 1;
    overflow: auto;
  }
  .p-icon {
    color: white;
    &:before {
      font-size: 32px;
    }
  }
  .p-image {
    &-add-label {
      width: 100%;
      height: 100%;
      &:hover {
        cursor: pointer;
      }
    }
    &-button,
    &-button-div {
      width: 200px;
    }
    &-button-div {
      background-color: $secondary-color;
      border-radius: 50px;
      color: white;
      font-weight: bold;
      letter-spacing: 0.75px;
      padding: 10px 0px 10px 0px;
      text-align: center;
      &:hover {
        cursor: pointer;
      }
    }
    &-mandatory-tag {
      border-radius: 3px;
      display: inline-block;
      padding: 8px 10px;
      min-width: 60%;
      font-size: 16px;
      font-weight: bold;
      letter-spacing: 0.5px;
    }
    &-overlay {
      background-color: rgba(0, 0, 0, 0.6);
      color: white;
      text-align: center;
      opacity: 0;
      position: absolute;
      height: 100%;
      width: 100%;
      top: 0;
      transition: opacity 0.3s ease-in-out;
      &:hover,
      &.show {
        opacity: 1;
      }
    }
    &-wrapper {
      background-color: #f8f9fa;
      width: 100%;
      aspect-ratio: auto 1 / 1;
      border-radius: 5px;
      border-width: 0px;
      position: relative;
    }
  }
}

@media only screen and (min-width: 600px) {
  #edit-family-groups {
    .p-icon:before {
      font-size: 48px;
    }
    .p-image-wrapper {
      aspect-ratio: 2 / 1;
    }
  }
}

@media only screen and (min-width: 960px) {
  #edit-family-groups {
    .p-icon:before {
      font-size: 64px;
    }
    .p-image-wrapper {
      aspect-ratio: 7 / 3;
    }
  }
}
</style>
